import * as React from 'react';

const SvgCheckOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 16 17"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M11.942 5.153a.75.75 0 0 1 .164 1.048l-4.375 6a.75.75 0 0 1-1.13.094L3.974 9.724a.75.75 0 1 1 1.05-1.072l2.005 1.965 3.864-5.3a.75.75 0 0 1 1.048-.164"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgCheckOutlined;
